import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AdvantagesSection from './components/AdvantagesSection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '什么是2048核处理器？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '2048核处理器是一种集成2048个独立计算核心的超大规模并行处理器，采用先进片上网络（NoC）互联技术，专为AI训练、科学计算与数据中心等高并行度工作负载设计。',
                },
              },
              {
                '@type': 'Question',
                name: '2048核处理器的核心优势是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '核心优势包括：PetaFLOPS级计算能力、极致能效比（较上代提升2.3倍）、硬件级多租户安全隔离、3D堆叠集成与HBM3高带宽内存，以及成熟的MPI+OpenMP编程生态支持。',
                },
              },
              {
                '@type': 'Question',
                name: '2048核处理器适用于哪些场景？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '适用于大型AI模型训练与推理、气候模拟与科学计算、数据中心规模化部署、金融风险建模、基因组分析、计算流体力学等多领域。',
                },
              },
              {
                '@type': 'Question',
                name: '如何为2048核架构优化应用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '推荐使用MPI+OpenMP混合编程模型，充分利用分布式内存与共享内存并行。对于非规则应用可尝试Legion等任务运行时，新项目可考虑Chapel语言提升开发效率。',
                },
              },
              {
                '@type': 'Question',
                name: '2048核处理器的功耗与散热如何解决？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '典型TDP在500W-800W之间，采用直接芯片液冷或列间精密空调方案。液冷方案可将PUE控制在1.08以下，结合动态功耗管理技术在低负载时显著降低能耗。',
                },
              },
            ],
          }),
        }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <AdvantagesSection />
        <FeaturedArticles />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}